import { Icon } from '@iconify/react'
import {
    FRESHNESS_LABELS, formatArea, formatCoords, formatDateTime, formatRelative, freshnessOf,
} from '../utils/events'

const Row = ({ icon, label, children }) => (
    <div className="detail__row">
        <Icon icon={icon} aria-hidden="true" />
        <div>
            <span className="detail__label">{label}</span>
            <span className="detail__value">{children}</span>
        </div>
    </div>
)

const EventDetail = ({ event, onClose }) => {
    const freshness = freshnessOf(event.timestamp)

    return (
        <aside className="detail" aria-label="Détail de l'événement">
            <div className="detail__head">
                <span className={`badge freshness--${freshness}`}>{FRESHNESS_LABELS[freshness]}</span>
                <button type="button" className="btn btn--icon" onClick={onClose} aria-label="Fermer le détail">
                    <Icon icon="mdi:close" aria-hidden="true" />
                </button>
            </div>

            <h2 className="detail__title">{event.title}</h2>
            {event.description && <p className="detail__description">{event.description}</p>}

            <Row icon="mdi:texture-box" label="Surface estimée">{formatArea(event.hectares)}</Row>
            <Row icon="mdi:clock-outline" label="Dernière observation">
                {formatDateTime(event.timestamp)}
                <span className="detail__hint"> ({formatRelative(event.timestamp)})</span>
            </Row>
            <Row icon="mdi:map-marker-outline" label="Coordonnées">
                {formatCoords(event.lat, event.lng)}
            </Row>
            <Row icon="mdi:earth" label="Région">{event.regionLabel}</Row>
            <Row icon="mdi:database-outline" label="Source">
                {event.sourceId}
                <span className="detail__hint">
                    {event.sourceId === 'IRWIN' ? ' · États-Unis' : ' · mondiale'}
                </span>
            </Row>
            <Row icon="mdi:pulse" label="Statut EONET">
                {event.isActive ? 'Événement ouvert' : 'Événement clôturé'}
            </Row>

            {event.sourceUrl && (
                <a className="btn btn--primary detail__link" href={event.sourceUrl} target="_blank" rel="noreferrer">
                    <Icon icon="mdi:open-in-new" aria-hidden="true" />
                    <span>Consulter la fiche source</span>
                </a>
            )}
        </aside>
    )
}

export default EventDetail
